module.exports = __webpack_public_path__ + "assets/icontact.165fcb4f.svg";